import { Theme, ThemeProvider } from "@emotion/react";
import _merge from "lodash/merge";
import React, { useMemo } from "react";
import { ChildrenPropsType } from "src/globalTypes";
import { usePersonalizationColors } from "../../../store/personalization/useSelectors";
import staticTheme from "./staticTheme";

const FlowioThemeProvider = ({ children }: ChildrenPropsType) => {
  const colors = usePersonalizationColors();

  const theme: Theme = useMemo(() => _merge(staticTheme, { colors }), [colors]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default FlowioThemeProvider;
